import { GoTrueClient } from '@supabase/gotrue-js'

const URL = import.meta.env.PROD
? import.meta.env.VITE_PROD_GOTRUE_URL as string
: import.meta.env.VITE_DEV_GOTRUE_URL as string

const goTrueClient = new GoTrueClient({ url: URL })

export default goTrueClient
